// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"588de408","897":"895d6550"}[chunkId] + ".chunk.js";
};